import { useSyncExternalStore } from 'react';
/**
 * SSR-safe media query subscription.
 * Note: inside a shadow root `matchMedia` still resolves against the top-level
 * viewport, which is what we want for the mobile/desktop switch.
 */
export function useMediaQuery(query) {
    return useSyncExternalStore((onChange) => {
        if (typeof window === 'undefined')
            return () => undefined;
        const list = window.matchMedia(query);
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
    }, () => (typeof window === 'undefined' ? false : window.matchMedia(query).matches), () => false);
}
/**
 * Full-screen sheet instead of the docked panel. Height counts too: a phone in
 * landscape is wider than 640px, but a 400px-wide panel squeezed into ~390px
 * of height leaves almost no room for the conversation.
 */
export const MOBILE_QUERY = '(max-width: 640px), (max-height: 500px)';
export function useIsMobile() {
    return useMediaQuery(MOBILE_QUERY);
}
